/**
 * Counsellor Incentives Dashboard API with request cancellation (AbortController).
 */
import { fetchWithAuth } from "./FetchWithAuth";
import { url } from "./url";

const BASE = `${String(url).replace(/\/+$/, "")}/api/incentives`;

function buildQuery(params) {
  const sp = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v != null && v !== "") sp.set(k, String(v));
  });
  const qs = sp.toString();
  return qs ? `?${qs}` : "";
}

async function request(path, options = {}) {
  const { signal, ...rest } = options;
  const endpoint = `${BASE}${path}`;
  const response = await fetchWithAuth(endpoint, {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(rest.headers || {}) },
    signal,
    ...rest,
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data?.error || `Request failed ${response.status}`);
  }
  return response.json();
}

export const incentivesApi = {
  getSummary: (params, signal) =>
    request(`/summary/${buildQuery(params)}`, { signal }),

  getBonusList: (params, signal) =>
    request(`/bonus/${buildQuery(params)}`, { signal }),

  getBountyList: (params, signal) =>
    request(`/bounty/${buildQuery(params)}`, { signal }),

  getCommissionList: (params, signal) =>
    request(`/commission/${buildQuery(params)}`, { signal }),

  getTargetsList: (params, signal) =>
    request(`/targets/${buildQuery(params)}`, { signal }),
};
